module.exports = __webpack_public_path__ + "static/media/gulfwarillness_image4.152538e3.jpg";